export default __webpack_public_path__ + "static/media/over-axlesGroup-size-weight.f18505a6.svg";